import React from 'react';
import './Footer.css';
import PICS from '../assets/images'
import { HiOutlineLocationMarker, HiOutlineMail, HiOutlinePhone } from "react-icons/hi";
import { FaInstagram } from "react-icons/fa";
import { Link } from 'react-router-dom';

const Footer = () => {
  return (
    <footer className="main-footer">
      <div className="footer-container">
        {/* Column 1: Brand & Social */}
        <div className="footer-column brand-column">
          <div className="footer-logo">
            <span className="logo-icon"><img src={PICS.logo} alt="logo" /></span>
            <span className="logo-text epilogue-font">EMIC STRATEGIES</span>
          </div>
          <p className="brand-tagline">
            Your trusted partner for Asian market research and cultural
            intelligence. Helping global companies succeed in Asia's dynamic
            markets.
          </p>
          <div className="social-links">
            {/* These are placeholder links for LinkedIn and Twitter */}
            <a href="#" className="social-icon">
              Top
            </a>
            {/* <a href="#" className="social-icon">
              T
            </a> */}
          </div>
        </div>

        {/* Column 2: Services */}
        <div className="footer-column">
          <h4 className="column-title">Company</h4>
          <nav className="footer-nav">
            <a href="/#home">About Us</a>
            <Link to="/blogs">Our Blog</Link>
            <a href="/#market-knowledge-section">The Glocal Advantage</a>
            <a href="/#contact-section">Get In Touch</a>
            <Link to="/privacy-policy">Privacy Policy</Link>
          </nav>
        </div>

        {/* Column 3: Contact */}
        <div className="footer-column">
          <h4 className="column-title">Contact</h4>
          <p>
            <span className="contact-icon"><HiOutlineMail className='contact-icons' /></span> info@emicstrategies.com
          </p>
          {/* <p>
            <span className="contact-icon"><HiOutlinePhone className='contact-icons' /></span> +
          </p> */}
          <p>
            <span className="contact-icon"><HiOutlineLocationMarker className='contact-icons' /></span> London, United Kingdom
          </p>
          <p className='footer-address'>71-75 Shelton Street, <br />
                  Covent Garden, <br />
                  WC2H 9JQ</p>
                  <p>
            <span className="contact-icon"><FaInstagram className='contact-icons' /></span>
            <a 
              href="https://www.instagram.com/emicstrategies" 
              target="_blank" 
              rel="noopener noreferrer"
              className="social-link-text"
              style={{ color: '#c7d1e3' }}
            >
              @emicstrategies
            </a>
          </p>
        </div>
      </div>

      {/* Footer Bottom Bar */}
      <div className="footer-bottom">
        <p className="copyright">
          &copy; 2025 EMIC STRATEGIES. All rights reserved.
        </p>
        <div className="legal-links">
          {/* <a href="#privacy">Privacy Policy</a>
          <a href="#terms">Terms of Service</a> */}
        </div>
      </div>
    </footer>
  );
};

export default Footer;